import { ColumnPreference } from 'entities/Preferences/types';

export const applyColumnPinPreferences = <T extends { columnName: string }>(
	columns: T[],
	savedPreferences: ColumnPreference[] = [],
): (T & { isPinned: boolean })[] => {
	const pinnedByName = new Map(savedPreferences.map((pref) => [pref.columnName, pref.isPinned]));

	return columns.map((column) => ({
		...column,
		isPinned: pinnedByName.get(column.columnName) ?? false,
	}));
};
